class SseSubscriptionRegistry {
  constructor() {
    this.entries = new Map();
  }

  subscribe(key, startTransport, listener) {
    let entry = this.entries.get(key);

    if (!entry) {
      const listeners = new Set();
      const stopTransport = startTransport((payload) => {
        listeners.forEach((cb) => cb(payload));
      });

      entry = { listeners, stopTransport };
      this.entries.set(key, entry);
    }

    entry.listeners.add(listener);

    return () => {
      const currentEntry = this.entries.get(key);
      if (!currentEntry) return;

      currentEntry.listeners.delete(listener);

      if (currentEntry.listeners.size === 0) {
        try {
          currentEntry.stopTransport?.();
        } finally {
          this.entries.delete(key);
        }
      }
    };
  }
}

export const sseSubscriptionRegistry = new SseSubscriptionRegistry();
